import React, { useContext } from "react";

import LocaleContext from "@/i18n";

import {
  Col1,
  Col2,
  Col3,
  FlexGrid,
  PrivacyPolicyLink,
  Text,
  TextCopyright,
} from "./styles";

export type FooterProps = {
  participants: number;
  hideParticipantsCount?: boolean;
  leftText?: string;
  onCopyrightClick: () => void;
  hasCopyrights: boolean;
  privacyPolicyLink?: string;
};

export const Footer: React.FC<FooterProps> = (
  props: FooterProps
): React.JSX.Element => {
  const localeContext = useContext(LocaleContext);
  const { translation } = localeContext;

  const {
    participants,
    hideParticipantsCount,
    leftText,
    onCopyrightClick,
    hasCopyrights,
    privacyPolicyLink,
  } = props;

  return (
    <FlexGrid data-qa="footer">
      <Col1>
        {leftText && <Text>{leftText}</Text>}
        {hasCopyrights && (
          <TextCopyright onClick={onCopyrightClick}>{"©"}</TextCopyright>
        )}
      </Col1>
      <Col2>
        {!hideParticipantsCount && participants > 0 && (
          <Text>
            <span>{participants.toLocaleString()}</span>
            {" " + translation.participants}
          </Text>
        )}
      </Col2>
      <Col3>
        {privacyPolicyLink && (
          <PrivacyPolicyLink href={privacyPolicyLink} target="_blank">
            {translation.dataProtection}
          </PrivacyPolicyLink>
        )}
      </Col3>
    </FlexGrid>
  );
};
